import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import ClassSessionPage from './ClassSessionPage';
import ClassSessions from './ClassSessionTable';

const ClassSessionsRoutes: React.FC = () => {
    const { path } = useRouteMatch();
    console.log('ClassSessions path', path);

    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={ClassSessions} />
                <Route exact path={`${path}/:classSessionUuid`} component={ClassSessionPage} />
            </Switch>
        </>
    );
};

export default ClassSessionsRoutes;
